// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navigation-drawer__container{position:relative;width:100%;height:100%}.navigation-drawer>.v-navigation-drawer__content{overflow:hidden;width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
